<template>
    <div class="redirect">
      <div class="content">
        <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
            <img src="img/brand/logo-amo.png" alt="logo" height="50px">
        </router-link>
        <h1 class="">Abrindo o WhatsApp...</h1>
        <div id="load-content-redirect">
          <div id="load-item-redirect-1" class="load-item-redirect"></div>
          <div id="load-item-redirect-2" class="load-item-redirect"></div>
          <div id="load-item-redirect-3" class="load-item-redirect"></div>
          <div id="load-item-redirect-4" class="load-item-redirect"></div>
          <div id="load-item-redirect-5" class="load-item-redirect"></div>
          <div id="load-item-redirect-6" class="load-item-redirect"></div>
          <div id="load-item-redirect-7" class="load-item-redirect"></div>
          <div id="load-item-redirect-8" class="load-item-redirect"></div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'redirect',
  mounted () {
    setTimeout(() => {
      window.location = 'https://api.whatsapp.com/send?phone=5511914516386&text=Gostaria%20de%20saber%20se%20tenho%20direito%20ao%20AUX%C3%ADLIO-MATERNIDADE.'
    }, 2000)
  }
}
</script>

<style lang="scss">
@import "../assets/scss/my-custom";
.redirect{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}

.content {
  text-align: center;
  .navbar-brand{
    margin-bottom: 2rem;
  }
  > h1 {
    text-align: center;
    width: 100%;
    color: $my-text-logo;
    font-weight: bold;
    margin-bottom: 2rem;
  }
  > div {
    width: 100%;
  }
  #load-content-redirect{
    position:relative;
    width: 32rem;
    height: 4rem;
    margin: 2rem auto;
    .load-item-redirect{
      position:absolute;
      top:0;
      background-color: $my-primary;
      width: 4rem;
      height: 4rem;
      animation-name:load-animation-redirect;
      -o-animation-name:load-animation-redirect;
      -ms-animation-name:load-animation-redirect;
      -webkit-animation-name:load-animation-redirect;
      -moz-animation-name:load-animation-redirect;
      animation-duration:1.5s;
      -o-animation-duration:1.5s;
      -ms-animation-duration:1.5s;
      -webkit-animation-duration:1.5s;
      -moz-animation-duration:1.5s;
      animation-iteration-count:infinite;
      -o-animation-iteration-count:infinite;
      -ms-animation-iteration-count:infinite;
      -webkit-animation-iteration-count:infinite;
      -moz-animation-iteration-count:infinite;
      animation-direction:normal;
      -o-animation-direction:normal;
      -ms-animation-direction:normal;
      -webkit-animation-direction:normal;
      -moz-animation-direction:normal;
      transform:scale(.3);
      -o-transform:scale(.3);
      -ms-transform:scale(.3);
      -webkit-transform:scale(.3);
      -moz-transform:scale(.3);
      border-radius:50%;
      -o-border-radius:50%;
      -ms-border-radius:50%;
      -webkit-border-radius:50%;
      -moz-border-radius:50%;
    }
    #load-item-redirect-1{
      left:0;
      animation-delay:0.6s;
      -o-animation-delay:0.6s;
      -ms-animation-delay:0.6s;
      -webkit-animation-delay:0.6s;
      -moz-animation-delay:0.6s;
    }
    #load-item-redirect-2{
      left: 4rem;
      animation-delay:0.75s;
      -o-animation-delay:0.75s;
      -ms-animation-delay:0.75s;
      -webkit-animation-delay:0.75s;
      -moz-animation-delay:0.75s;
    }
    #load-item-redirect-3{
      left: 8rem;
      animation-delay:0.9s;
      -o-animation-delay:0.9s;
      -ms-animation-delay:0.9s;
      -webkit-animation-delay:0.9s;
      -moz-animation-delay:0.9s;
    }
    #load-item-redirect-4{
      left: 12rem;
      animation-delay:1.05s;
      -o-animation-delay:1.05s;
      -ms-animation-delay:1.05s;
      -webkit-animation-delay:1.05s;
      -moz-animation-delay:1.05s;
    }
    #load-item-redirect-5{
      left: 16rem;
      animation-delay:1.2s;
      -o-animation-delay:1.2s;
      -ms-animation-delay:1.2s;
      -webkit-animation-delay:1.2s;
      -moz-animation-delay:1.2s;
    }
    #load-item-redirect-6{
      left: 20rem;
      animation-delay:1.35s;
      -o-animation-delay:1.35s;
      -ms-animation-delay:1.35s;
      -webkit-animation-delay:1.35s;
      -moz-animation-delay:1.35s;
    }
    #load-item-redirect-7{
      left: 24rem;
      animation-delay:1.5s;
      -o-animation-delay:1.5s;
      -ms-animation-delay:1.5s;
      -webkit-animation-delay:1.5s;
      -moz-animation-delay:1.5s;
    }
    #load-item-redirect-8{
      left: 28rem;
      animation-delay:1.64s;
      -o-animation-delay:1.64s;
      -ms-animation-delay:1.64s;
      -webkit-animation-delay:1.64s;
      -moz-animation-delay:1.64s;
    }
  }
  @media screen and (max-width: 600px){
    #load-content-redirect{
      width: 16rem;
      margin-bottom: 20vh;
      .load-item-redirect{
        width: 2rem;
        height: 2rem;
      }
      #load-item-redirect-2{
        left: 2rem;
      }
      #load-item-redirect-3{
        left: 4rem;
      }
      #load-item-redirect-4{
        left: 6rem;
      }
      #load-item-redirect-5{
        left: 8rem;
      }
      #load-item-redirect-6{
        left: 10rem;
      }
      #load-item-redirect-7{
        left: 12rem;
      }
      #load-item-redirect-8{
        left: 14rem;
      }
    }
  }
}
@keyframes load-animation-redirect{
  0%{
    transform:scale(1);
    background-color: $my-primary;
  }
  100%{
    transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}
@-o-keyframes load-animation-redirect{
  0%{
    -o-transform:scale(1);
    background-color: $my-primary;
  }
  100%{
    -o-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}
@-ms-keyframes load-animation-redirect{
  0%{
    -ms-transform:scale(1);
    background-color: $my-primary;
  }
  100%{
    -ms-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}
@-webkit-keyframes load-animation-redirect{
  0%{
    -webkit-transform:scale(1);
    background-color: $my-primary;
  }
  100%{
    -webkit-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}
@-moz-keyframes load-animation-redirect{
  0%{
    -moz-transform:scale(1);
    background-color: $my-primary;
  }
  100%{
    -moz-transform:scale(.3);
    background-color:rgb(255,255,255);
  }
}
</style>
